import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _class2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "a38d54qNwNO24vTtYZN67rT", "AdEvent", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, log } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property;

var AdEvent = ccclass(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AdEvent, _Component);

  function AdEvent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_eventList", new Map());

    return _this;
  }

  var _proto = AdEvent.prototype;

  _proto.onLoad = function onLoad() {// AdEvent._I = this;
  };

  _proto.addEventLintener = function addEventLintener(type, callback, target) {
    var eventInfo = this._eventList.get(type);

    var isHandle = false;

    if (eventInfo && eventInfo.length > 0) {
      for (var i = 0; i < eventInfo.length; ++i) {
        if (eventInfo[i].target == target) {
          eventInfo[i].callback = callback;
          isHandle = true;
          break;
        }
      }

      if (!isHandle) {
        eventInfo.push({
          callback: callback,
          target: target
        });

        this._eventList.set(type, eventInfo);
      }
    } else {
      this._eventList.set(type, [{
        callback: callback,
        target: target
      }]);
    }
  };

  _proto.removeEvent = function removeEvent(target) {
    for (var k in this._eventList) {
      var eventInfo = this._eventList.get(k);

      if (eventInfo.length > 0) {
        for (var i = 0; i < eventInfo.length; ++i) {
          if (!eventInfo[i]) {
            log("eventInfo[i] --------", eventInfo);
            continue;
          }

          if (eventInfo[i].target == target) {
            var index = eventInfo.indexOf(eventInfo[i]);
            eventInfo.splice(index, 1);

            this._eventList.set(k, eventInfo);
          }
        }
      }
    }
  } //處理事件
  ;

  _proto.handleEvent = function handleEvent(type) {
    // if (type == E_ADEventType.video_showOver) {
    //     DataAnalyze.I.ad(E_DataAnalyzeType.Ad_End);
    //     switch (App.AdCtrl.type) {
    //         case E_AdType.PreGain:
    //             DataAnalyze.I.ad(E_DataAnalyzeType.Ad_PreGain);
    //             break;
    //         case E_AdType.Reborn:
    //             DataAnalyze.I.ad(E_DataAnalyzeType.Ad_Reborn);
    //             break;
    //         case E_AdType.Result:
    //             if (App.GameCtrl.gameMode == E_GameMode.Indiana) {
    //                 DataAnalyze.I.ad(E_DataAnalyzeType.Ad_ResultIndiana);
    //             } else if (App.GameCtrl.gameMode == E_GameMode.Survival) {
    //                 DataAnalyze.I.ad(E_DataAnalyzeType.Ad_ResultSurvival);
    //             } else if (App.GameCtrl.gameMode == E_GameMode.Time) {
    //                 DataAnalyze.I.ad(E_DataAnalyzeType.Ad_ResultTime);
    //             }
    //             break;
    //         case E_AdType.SkinShop:
    //             DataAnalyze.I.ad(E_DataAnalyzeType.Ad_Skin);
    //             break;
    //         case E_AdType.WeaponShop:
    //             DataAnalyze.I.ad(E_DataAnalyzeType.Ad_Weapon);
    //             break;
    //     }
    // }
    var eventInfo = this._eventList.get(type);

    if (eventInfo && eventInfo.length > 0) {
      for (var _len2 = arguments.length, restOfName = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        restOfName[_key2 - 1] = arguments[_key2];
      }

      for (var i = 0; i < eventInfo.length; ++i) {
        if (!eventInfo[i]) {
          continue;
        }

        eventInfo[i].callback.call(eventInfo[i].target, restOfName[0], restOfName);
      }
    }
  };

  _createClass(AdEvent, null, [{
    key: "I",
    get: function get() {
      if (!AdEvent._I) {
        AdEvent._I = new AdEvent();
      }

      return AdEvent._I;
    }
  }]);

  return AdEvent;
}(Component), _defineProperty(_class2, "_I", null), _temp)) || _class;

export { AdEvent as default };

_cclegacy._RF.pop();